import React, { ReactElement } from 'react';

type Props = {
  height?: number | string;
  style?: React.CSSProperties;
  width?: number | string;
};

const Plus = ({ height, style, width }: Props): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      style={style}
    >
      <path
        fill="currentColor"
        d="M19.505 11.286h-6.791V4.5c-.016-.388-.33-.69-.714-.69l-.078.004c-.358.039-.636.342-.636.71v6.76l-6.785.001c-.388.016-.69.33-.69.714 0 .383.302.698.684.714h6.791v6.785c.016.388.33.69.714.69l.078-.004c.358-.039.636-.342.636-.71v-6.761H19.5c.388-.016.69-.33.69-.714 0-.383-.302-.698-.684-.714z"
      />
    </svg>
  );
};

Plus.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Plus;
